import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { addDays, dateDiff, fechaCV, fFecha, obtenerDiaSemana, soloDia, TipoDateDiff } from 'src/app/core/Funciones/fFecha';
import { mostrarSwalConfirm, mostrarSwalError } from 'src/app/core/Funciones/funciones';
import { AccesoDatosService } from 'src/app/core/services/acceso-datos.service';
import { IEmpleados, nombreEmpleado } from 'src/app/models/empleados';
import { crearHorarioDesdeIncidencia, IHorarios, IHorariosEmpleado, IHorariosIncidencias } from 'src/app/models/horarios';
import { convertirAHorarioIncidenciaDetalle, DatosIncidencias, IAccesoIncidenciasUsuario } from 'src/app/models/incidencias';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-cambiar-horario',
  templateUrl: './cambiar-horario.component.html',
  styleUrls: ['./cambiar-horario.component.scss']
})
export class CambiarHorarioComponent implements OnInit {
  public empleadoSeleccionado: IEmpleados | undefined = undefined;
  public empleados: IEmpleados[] = [];
  public empleadosOrigen: IEmpleados[] = [];
  public esDebugger: boolean = false;
  public horarioSeleccionadoEmpleado: IHorarios = new IHorarios();
  public fechaValidacionTxt: string = '';
  public incidenciaCambio: IHorariosIncidencias =  new IHorariosIncidencias();

  @Input()
  public incidenciaValidacion!: DatosIncidencias;

  @Input()
  public agregarHorarioValidacion: boolean = false;

  @Input()
  public horarioValidacion: IHorarios = new IHorarios();

  @Input()
  public diaIncidenciaValidacion: any = undefined;

  @Input()
  public incidenciasDelDiaValidacion: DatosIncidencias[] = [];

  @Output()
  public horarioEntradaCambio = new EventEmitter<any>();

  @Output()
  public horarioSalidaCambio = new EventEmitter<any>();

  @Input()
  public esValidacion: boolean = false;

  @Input()
  public horariosEmpleado: IHorariosEmpleado[] = [];

  @Input()
  public nuevaIncidencia: IAccesoIncidenciasUsuario = new IAccesoIncidenciasUsuario();

  @Output()
  public incidenciaCambioEmitida = new EventEmitter<IHorariosIncidencias>();

  constructor(
    private accesoDatosService: AccesoDatosService,
    public dialogRef?: MatDialogRef<CambiarHorarioComponent>,
    @Inject(MAT_DIALOG_DATA) public data?: { incidencia: DatosIncidencias, agregarHorario: boolean, horario: IHorarios, diaIncidencia: any, incidenciasDelDia: DatosIncidencias[] },
  ) {
    this.cargarDatos();
    console.log('nuevaIncidencia datos:', this.nuevaIncidencia);
  }

  public cargarDatos() {
    this.esDebugger = this.accesoDatosService.getModoDebug();
    this.accesoDatosService.empleadosListado().subscribe(
      (empleados: IEmpleados[]) => {
        this.empleados = empleados;
        this.empleadosOrigen = empleados;
        this.empleados.forEach(empleado => {
          (empleado as any)['nombreCompleto'] = `${empleado.nombre} ${empleado.paterno ? empleado.paterno : ''} ${empleado.materno ? empleado.materno : ''}`;
        });
        this.empleados = this.empleadosOrigen.filter(x => !x.baja || x.baja.getTime() <= new Date(1900, 1, 1).getTime()).sort(
          (a, b) => +a.numero - +b.numero || a.nombre?.toLowerCase().localeCompare(b.nombre?.toLowerCase())
        );
      },
      (error) => {
        this.accesoDatosService.logAgrega2("Error al cargar los datos de los empleados");
        console.error(error);
        this.empleados = [];
        this.empleadosOrigen = [];
      }
    );
  }

  public nombreCompleto(empleado: IEmpleados): string {
    return nombreEmpleado(empleado);
  }

  public aplicarCambioTurno() {
    const empleadoEncontrado = this.empleados.find((empleado) => empleado == this.empleadoSeleccionado);
    if (!this.empleadoSeleccionado) {
      mostrarSwalConfirm('Deberá de seleccionar un empleado para realizar el cambio de turno', 'error');
      return;
    }

    if (this.empleadoSeleccionado != empleadoEncontrado) {
      mostrarSwalConfirm('Verifique que el nombre este bien escrito o bien selecciónelo de la lista', 'error');
      return;
    }

    // this.accesoDatosService.horarioIncidenciaModificar().subscribe((response) => {
    //   if (this.data && this.dialogRef && this.empleadoSeleccionado) {
    //     mostrarSwalConfirm(`Cambio de turno aplicado de: ${this.data.incidencia.nombre} para: ${this.nombreCompleto(this.empleadoSeleccionado)} correctamente`, 'success');
    //     this.dialogRef.close();
    //   }},
    //   (error) => {
    //     console.error('Error en la petición:', error);
    //     mostrarSwalError('Error al cambiar de turno', error.message || 'Error desconocido');
    //   }
    // );
  }

  public aplicarAsignarHorario() {
    mostrarSwalConfirm(`Asignación de horario aplicado correctamente`, 'success');
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  public formatoFecha(fecha: Date | undefined){
    if (!fecha) {
      return '-';
    }

    return fFecha(fecha, "FSL")
  }

  public obtenerHorario() {
    let idEmpleado: number = !this.empleadoSeleccionado || !this.empleadoSeleccionado.id ? 0 : +this.empleadoSeleccionado.id;
    if (!idEmpleado) {
      mostrarSwalError('Horarios', 'No se puede localizar el empleado seleccionado');
      return;
    }

    if (this.data?.incidenciasDelDia) {
      let horarioIncidenciaEmpleado = this.data.incidenciasDelDia.find(inc => inc.idEmpleado == idEmpleado);
      if (!horarioIncidenciaEmpleado) {
        mostrarSwalError('Horarios', 'No se puede obtener el horario');
        return;
      }

      this.horarioSeleccionadoEmpleado = crearHorarioDesdeIncidencia(horarioIncidenciaEmpleado.detalleHorarioDia, horarioIncidenciaEmpleado.fecha, horarioIncidenciaEmpleado.horario);
    } else if (this.esValidacion) {
      if (!this.empleadoSeleccionado || !this.empleadoSeleccionado.id) return;
      this.fechaValidacionTxt = obtenerDiaSemana(this.nuevaIncidencia.inicio);
      let dia1: Date = this.nuevaIncidencia.inicio;
      let dias: number = dateDiff(this.nuevaIncidencia.inicio, this.nuevaIncidencia.fin, TipoDateDiff.días) + 1;
      dia1 = soloDia(addDays(this.nuevaIncidencia.inicio, dias - 1));
      let horario: IHorarios | undefined = this.obtenerHorarioEmpleado(+this.empleadoSeleccionado.id, dia1);
      if (!horario) {
        mostrarSwalError('Error', 'No se encontró un horario válido para el empleado seleccionado.');
        return;
      }
      this.horarioSeleccionadoEmpleado = horario;
      this.modificarHorarioIncidencia();
      this.incidenciaCambioEmitida.emit(this.incidenciaCambio);
    } else {
      mostrarSwalError('Horarios', 'No se puede obtener el horario');
    }
  }

  private obtenerHorarioEmpleado(idEmpleado: number, dia: Date): IHorarios | undefined {
    let horarioEmpleado: IHorariosEmpleado | undefined = this.horariosEmpleado.find(x => x.idEmpleado == idEmpleado);
    if (!horarioEmpleado) {
      // console.log(Horarios de TODOS los empleados:, this.horariosEmpleado);
      return undefined;
    }

    return horarioEmpleado.horarios.find(x => x.inicio <= dia && x.fin >= dia);
  }

  public limpiarFiltro() {
    this.empleadoSeleccionado = undefined;
  }

  public emitirHorarioEntrada(data: any) {
    this.horarioEntradaCambio.emit(data);
  }

  public emitirHorarioSalida(data: any) {
    this.horarioSalidaCambio.emit(data);
  }

  public modificarHorarioIncidencia() {
    const detalle = convertirAHorarioIncidenciaDetalle(this.horarioSeleccionadoEmpleado, this.fechaValidacionTxt);
    let esDescanso = this.horarioSeleccionadoEmpleado.detalles[0].diasDescanso.length > 0 && this.horarioSeleccionadoEmpleado.detalles[0].diasDescanso.includes(this.fechaValidacionTxt);
    this.incidenciaCambio = {
      id: this.nuevaIncidencia.id,
      idEmpresa: this.nuevaIncidencia.idEmpresa,
      idEmpleado: this.nuevaIncidencia.idEmpleado,
      inicio: this.nuevaIncidencia.inicio,
      inicioTxt: this.nuevaIncidencia.inicioTxt,
      fin: this.nuevaIncidencia.fin,
      finTxt: this.nuevaIncidencia.finTxt,
      horario: detalle, // usar esta función ++ convertirAHorarioIncidenciaDetalle ++ se debe enviar los datos de horario del día ejemplo: '[ {"horaEntrada": 16.5, "horaSalida": 18, "nocturno": false} ]'
      esDescanso: esDescanso,
      esNocturno: this.horarioSeleccionadoEmpleado.nocturno,
      horarioDia: this.horarioSeleccionadoEmpleado.detalles[0].horariosSemana[this.fechaValidacionTxt],
      idIncidenciaUsuario: 0,
      tipoHorario: this.horarioSeleccionadoEmpleado.tipoHorario,
      manejoHorario: this.horarioSeleccionadoEmpleado.manejoHorario,
    };
    if (!environment.production || this.esDebugger) console.log(`Modificar horario de la incidencia:`, this.incidenciaCambio);
  }

  ngOnInit(): void {
    if (!this.incidenciaValidacion && this.data?.incidencia) {
      this.incidenciaValidacion = this.data.incidencia;
    }
    if (!this.agregarHorarioValidacion && this.data?.agregarHorario !== undefined) {
      this.agregarHorarioValidacion = this.data.agregarHorario;
    }
    if (!this.horarioValidacion && this.data?.horario) {
      this.horarioValidacion = this.data.horario;
    }
    if (!this.diaIncidenciaValidacion && this.data?.diaIncidencia) {
      this.diaIncidenciaValidacion = this.data.diaIncidencia;
    }
    if ((!this.incidenciasDelDiaValidacion || this.incidenciasDelDiaValidacion.length === 0) && this.data?.incidenciasDelDia) {
      this.incidenciasDelDiaValidacion = this.data.incidenciasDelDia;
    }
  }
}
